<template>
    <Card :header="$t('filters')">

        <form @keyup.enter="parentComponent.filterData()">

            <b-form-group :label="$t('id')" label-cols-sm="3">
                <b-form-input v-model="parentComponent.filters.id" :disabled="loading" />
            </b-form-group>

            <b-form-group :label="$t('productId')" label-cols-sm="3">
                <b-form-input v-model="parentComponent.filters.catalogId" :disabled="loading" />
            </b-form-group>

            <b-form-group :label="$t('risk')" label-cols-sm="3">
                <div class="d-flex gap-3">
                    <b-input-group :prepend="$t('from')">
                        <b-form-input
                            v-model.number="parentComponent.filters.riskScoreFrom"
                            v-decimal="{
                                min: riskMinVal,
                                max: parentComponent.filters.riskScoreTo ?? riskMaxVal,
                                precision: 2,
                                step: 0.01,
                            }"
                            :disabled="loading"
                        />
                        <b-input-group-append>
                            <span class="input-group-text">
                                <ButtonIcon
                                    v-b-tooltip.hover.noninteractive
                                    :title="$t('clear')"
                                    icon="x"
                                    :icon-size="14"
                                    size="sm"
                                    variant="link"
                                    class="p-0 rounded-max text-secondary line-height-1"
                                    pill
                                    :disabled="loading"
                                    @click="parentComponent.filters.riskScoreFrom = null"
                                />
                            </span>
                        </b-input-group-append>
                    </b-input-group>
                    <b-input-group :prepend="$t('to')">
                        <b-form-input
                            v-model.number="parentComponent.filters.riskScoreTo"
                            v-decimal="{
                                min: parentComponent.filters.riskScoreFrom ?? riskMinVal,
                                max: riskMaxVal,
                                precision: 2,
                                step: 0.01,
                            }"
                            :disabled="loading"
                        />
                        <b-input-group-append>
                            <span class="input-group-text">
                                <ButtonIcon
                                    v-b-tooltip.hover.noninteractive
                                    :title="$t('clear')"
                                    icon="x"
                                    :icon-size="14"
                                    size="sm"
                                    variant="link"
                                    class="p-0 rounded-max text-secondary line-height-1"
                                    pill
                                    :disabled="loading"
                                    @click="parentComponent.filters.riskScoreTo = null"
                                />
                            </span>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </b-form-group>

            <b-form-group v-if="requestRiskDimensions.getLoading()" class="d-flex justify-content-center">
                <b-spinner />
            </b-form-group>

            <template v-else>

                <ErrorMessage :value="requestRiskDimensions.getError()" />

                <template v-for="risk in riskDimensions">
                    <b-form-group :key="risk.value" :label="`${$t('risk')} ${risk.label}`" label-cols-sm="3">
                        <div class="d-flex gap-3">
                            <b-input-group :prepend="$t('from')">
                                <b-form-input
                                    v-model.number="parentComponent.filters.riskScoresFrom[risk.value]"
                                    v-decimal="{
                                        min: riskMinVal,
                                        max: parentComponent.filters.riskScoresTo[risk.value] ?? riskMaxVal,
                                        precision: 2,
                                        step: 0.01,
                                    }"
                                    :disabled="loading"
                                />
                                <b-input-group-append>
                                    <span class="input-group-text">
                                        <ButtonIcon
                                            v-b-tooltip.hover.noninteractive
                                            :title="$t('clear')"
                                            icon="x"
                                            :icon-size="14"
                                            size="sm"
                                            variant="link"
                                            class="p-0 rounded-max text-secondary line-height-1"
                                            pill
                                            :disabled="loading"
                                            @click="parentComponent.filters.riskScoresFrom[risk.value] = null"
                                        />
                                    </span>
                                </b-input-group-append>
                            </b-input-group>
                            <b-input-group :prepend="$t('to')">
                                <b-form-input
                                    v-model.number="parentComponent.filters.riskScoresTo[risk.value]"
                                    v-decimal="{
                                        min: parentComponent.filters.riskScoresFrom[risk.value] ?? riskMinVal,
                                        max: riskMaxVal,
                                        precision: 2,
                                        step: 0.01,
                                    }"
                                    :disabled="loading"
                                />
                                <b-input-group-append>
                                    <span class="input-group-text">
                                        <ButtonIcon
                                            v-b-tooltip.hover.noninteractive
                                            :title="$t('clear')"
                                            icon="x"
                                            :icon-size="14"
                                            size="sm"
                                            variant="link"
                                            class="p-0 rounded-max text-secondary line-height-1"
                                            pill
                                            :disabled="loading"
                                            @click="parentComponent.filters.riskScoresTo[risk.value] = null"
                                        />
                                    </span>
                                </b-input-group-append>
                            </b-input-group>
                        </div>
                    </b-form-group>
                </template>

            </template>

            <div class="d-flex gap-3">
                <ButtonIcon :disabled="loading" @click="parentComponent.filterData()">
                    {{ $t('filter') }}
                </ButtonIcon>
                <ButtonIcon variant="light" :disabled="loading" @click="parentComponent.resetData()">
                    {{ $t('reset') }}
                </ButtonIcon>
            </div>

        </form>
    </Card>
</template>



<script>
    export default {
        name: 'Filters',
        inject: {
            parentComponent: {
                default: null,
            },
        },
        data() {
            return {
                requestRiskDimensions: this.parentComponent.requestRiskDimensions,
                riskMinVal: 0,
                riskMaxVal: 10,
            };
        },
        computed: {
            loading() {
                return this.parentComponent.loading || this.requestRiskDimensions.getLoading();
            },
            riskDimensions() {
                return this.parentComponent.riskDimensions;
            },
        },
    };
</script>
